import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { PipesModule } from '../../pipes';
import { UploadListComponent } from './upload-list.component';

@NgModule({
    imports: [TwcModule, CommonModule, TranslateModule, PipesModule, DirectivesModule],
    declarations: [UploadListComponent],
    exports: [UploadListComponent],
})
export class UploadListModule {}
